import React from 'react'
import { Circle, Group, Line, Text } from 'react-konva'
import type { Measurement } from '../../utils/measurement.logic'
import { calculateMeasurementLength, formatMeasurementLength } from '../../utils/measurement.logic'

interface Props {
  measurement: Measurement | null
  previewPoint: { x: number; y: number } | null
  stageScale: number
}

export const MeasurementOverlay: React.FC<Props> = ({ measurement, previewPoint, stageScale }) => {
  if (!measurement || measurement.points.length === 0) return null
  const points = measurement.points.map(point => [point.x, point.y]).flat()
  const last = measurement.points[measurement.points.length - 1]
  const displayPoints = previewPoint ? [...points, previewPoint.x, previewPoint.y] : points
  const previewMeasurement = previewPoint
    ? { ...measurement, points: [...measurement.points, { ...previewPoint, source: 'grid' as const }] }
    : measurement
  const length = calculateMeasurementLength(previewMeasurement)
  const labelX = previewPoint?.x ?? last.x
  const labelY = previewPoint?.y ?? last.y
  const stroke = measurement.mode === 'direct' ? '#f59e0b' : '#22d3ee'
  return (
    <Group listening={false}>
      <Line points={displayPoints} stroke={stroke} strokeWidth={2 / Math.max(stageScale, 0.25)} dash={measurement.mode === 'direct' ? [8, 5] : undefined} lineCap="round" lineJoin="round" />
      {measurement.points.map((point, index) => <Circle key={`${point.x}-${point.y}-${index}`} x={point.x} y={point.y} radius={4 / Math.max(stageScale, 0.25)} fill={stroke} stroke="#0b1220" strokeWidth={1 / Math.max(stageScale, 0.25)} />)}
      <Group x={labelX + 8 / Math.max(stageScale, 0.25)} y={labelY - 22 / Math.max(stageScale, 0.25)}>
        <Text text={`${measurement.mode === 'direct' ? 'Прямая' : 'Ортогональная'} · ${formatMeasurementLength(length)}`} fill="#f8fafc" fontSize={12 / Math.max(stageScale, 0.25)} fontFamily="Inter, sans-serif" padding={4} fillAfterStrokeEnabled stroke="#0b1220" strokeWidth={3 / Math.max(stageScale, 0.25)} />
      </Group>
    </Group>
  )
}
